<div class="flex align-start justify-start gap-10 m-10 fw-500">
  <app-icon name="warning" class="material-symbols-outlined icon mt-5"></app-icon>
  <h2 mat-dialog-title class="flex align-center p-0 flex-1">Use Safari to Add to Calendar</h2>
</div>
<mat-dialog-content class="dialog-text">
  Adding events to Apple Calendar isn’t supported in Chrome on iPhone. Please open this page in Safari to add the event
  to your calendar.
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="primary-btn" (click)="continue()" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
